<template>
  <FormContainer v-if="moduleEnCours?.typeModule === 'Externe'">
    <template #title>Modalité de paiement</template>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          :model-value="moduleEnCours!.avecSubrogation"
          @update:model-value="(value: any) => updateModule('avecSubrogation', activeModuleIndex!, value)"
          label="Paiement direct à l'organisme de formation"
          :items="OuiOuNon"
          :required="metaModuleEnCours?.avecSubrogation?.$status === PropertyStatus.Required"
          :alertLabel="metaModuleEnCours?.avecSubrogation?.$messageErreurDirty!"
          :readonly
          class="col-10 col-md-14 col-sm-36"
        />
      </div>
    </template>
  </FormContainer>
  <FraisFormation
    :frais-data-par-mode
    :readonly
    :nature-frais="store.lov.NatureFrais"
    :modifie-frais
  />
</template>

<script setup lang="ts">
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/PROA'
import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
import { FormContainer, FraisFormation } from '@/features/interface/demande/shared'
import { OuiOuNon } from '@/features/interface/shared/tools'
import { inject } from 'vue'
import { useDemandePROAStore } from '../../../../useDemandePROAStore'
import { PROA_MODULES_ACTIONS } from '../../useModuleActions'

  const store = useDemandePROAStore()
  const { moduleEnCours, metaModuleEnCours, activeModuleIndex, modifieFrais, readonly, fraisDataParMode,  } =
    inject(PROA_MODULES_ACTIONS)!

  const { setupArrayUpdaterWithKey } = store

  const updateModule = setupArrayUpdaterWithKey<ModuleDTO>('formation.modules')

</script>
